// client/src/routes/app/contracts/index.tsx — SCR-CON-001 · CON-005 (04 §8.4).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner. The test that
// pins UI-003's "all V1 module routes exist in the sidebar, may point to placeholder pages"
// moves with it, to the next screen that is still a placeholder — the third such move, and the
// one PROP-004's deviation 369 and TEN-004's D-378 both predicted. See DEVIATIONS D-386.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and
// the screen reads it back typed, so a filtered list is shareable, survives refresh, and Back
// is a filter-undo.
//
// `Leasing.Read` is UI-003's guard and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ContractList } from '@/features/contracts/ContractList';
import { contractSearchSchema, type ContractSearch } from '@/features/contracts/search';

export const Route = createFileRoute('/app/contracts/')({
  validateSearch: contractSearchSchema,
  component: ContractsScreen,
});

function ContractsScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Leasing.Read">
      <ContractList
        search={search}
        onSearchChange={(next: (previous: ContractSearch) => ContractSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
